<template>
    <div :id="`${linkNav}`" class="Request">
          <h2>{{ title }}</h2>
          <hr />

          <!-- Links de configuração -->
          <div v-if="configLinks && configLinks.length" class="config-links mb-3">
            <b-alert show variant="info" class="py-2">
              <strong>Pré-requisitos:</strong>
              <ul class="mb-0 mt-1">
                <li v-for="link in configLinks" :key="link.label">
                  <router-link :to="link.route">{{ link.label }}</router-link>
                  <span v-if="link.hint" class="text-muted"> — {{ link.hint }}</span>
                </li>
              </ul>
            </b-alert>
          </div>

          <div class="description-block">
            <b>Descrição:</b>
            <p v-for="(line, i) in descriptionLines" :key="i" class="mb-1">{{ line }}</p>
          </div>

          <!-- Request -->
          <b-card v-if="titleRequest" class="mt-1" header-tag="header">
            <template #header>
              <h4 class="mb-0">{{ titleRequest }}</h4>
            </template>
            <div v-if="codeRequest.headers">
              <b-card-header>Headers :</b-card-header>
              <pre><code>{{ formatJson(codeRequest.headers) }}</code></pre>
            </div>
            <div v-if="codeRequest.body">
              <b-card-header>Body :</b-card-header>
              <pre><code>{{ formatJson(codeRequest.body) }}</code></pre>
            </div>
          </b-card>
          <br v-if="titleRequest"/>

          <!-- Response -->
          <b-card v-if="codeResponse" class="mt-1" header-tag="header">
            <template #header>
              <h4 class="mb-0">Resposta</h4>
            </template>
            <pre><code>{{ formatJson(codeResponse) }}</code></pre>
          </b-card>
          <br v-if="codeResponse"/>

          <!-- Curl -->
          <b-card v-if="curlExample" class="mt-1" header-tag="header">
            <template #header>
              <h4 class="mb-0">Exemplo cURL</h4>
            </template>
            <div class="curl-container">
              <pre class="curl-pre"><code>{{ curlExample }}</code></pre>
              <b-button
                size="sm"
                variant="outline-secondary"
                class="copy-btn"
                @click="copyCurl"
              >
                {{ copied ? 'Copiado!' : 'Copiar' }}
              </b-button>
            </div>
          </b-card>
          <br v-if="curlExample"/>

          <!-- Exceções -->
          <b-card v-if="exceptions && exceptions.length" class="mt-1" header-tag="header">
            <template #header>
              <h4 class="mb-0">Excecoes</h4>
            </template>
            <b-table-simple hover small responsive class="mb-0">
              <b-thead head-variant="light">
                <b-tr>
                  <b-th style="width: 15%">Codigo</b-th>
                  <b-th style="width: 20%">Excecao</b-th>
                  <b-th style="width: 30%">Mensagem</b-th>
                  <b-th style="width: 35%">Quando ocorre</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="row in exceptionRows"
                  :key="row.key"
                >
                  <b-td>
                    <b-badge :variant="row.code >= 500 ? 'danger' : row.code >= 400 ? 'warning' : 'info'">
                      {{ row.code }}
                    </b-badge>
                  </b-td>
                  <b-td><strong>{{ row.name }}</strong></b-td>
                  <b-td><code>{{ row.message }}</code></b-td>
                  <b-td>{{ row.occurrence }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card>
          <br v-if="exceptions && exceptions.length"/>
    </div>
</template>

<script>
import config from '../helpers/generalConfig';

export default {
  name: 'CardRequest',
  data(){
    return {
      sandboxHost: config.sandboxServer,
      copied: false
    }
  },
  props: {
    title: String,
    linkNav: String,
    description: String,
    titleRequest: String,
    codeRequest: { type: Object, default: () => ({}) },
    codeResponse: Object,
    exceptions: Array,
    route: String,
    curlExample: String,
    configLinks: Array
  },
  computed: {
    descriptionLines() {
      if (!this.description) return [];
      if (Array.isArray(this.description)) return this.description;
      return this.description.split('\n');
    },
    exceptionRows() {
      if (!this.exceptions) return [];
      const rows = [];
      this.exceptions.forEach(ex => {
        ex.cases.forEach((cas, i) => {
          rows.push({
            key: ex.name + '_' + i,
            code: ex.code,
            name: ex.name,
            message: cas.message,
            occurrence: cas.occurrence
          });
        });
      });
      return rows;
    }
  },
  methods: {
    formatJson(obj) {
      return JSON.stringify(obj, null, 2);
    },
    copyCurl() {
      if (!this.curlExample) return;
      navigator.clipboard.writeText(this.curlExample).then(() => {
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 2000);
      });
    }
  }
};
</script>

<style scoped>
.curl-container {
  position: relative;
}
.curl-pre {
  white-space: pre-wrap;
  word-break: break-all;
}
.copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}
.config-links a {
  color: #861f1f;
  font-weight: 600;
}
.config-links a:hover {
  text-decoration: underline;
}
</style>
